export default __webpack_public_path__ + "static/media/visa.a301b3b8.svg";